import { useContext } from 'react'
import { TenantContext } from '../store/Store'
import { AddressModel } from '../models/AddressModel'

export const useTenant = () => {
    return useContext<AddressModel | undefined>(TenantContext)
}
